import '../assets/styles/Servicos.css';
import imgControle from '../assets/images/controle_acesso.avif';
import imgLimpeza from '../assets/images/limpeza-geral.webp';
import imgEletrica from '../assets/images/eletrica.avif';
import imgDocas from '../assets/images/Docas.avif';
import imgCameras from '../assets/images/cameras-alarmes.avif';
import imgOutros from '../assets/images/outros.avif';
import ServiceCard from './ServiceCard';

export default function Servicos() {
  const servicos = [
    {
      id: 1,
      title: "Elétrica e Hidráulica",
      description: "Realizamos instalações, manutenções e reparos em sistemas elétricos e hidráulicos prediais em escolas, residências e empresas, garantindo o bom funcionamento e a segurança do seu ambiente.",
      image: imgEletrica
    },
    {
      id: 2,
      title: "Alarmes e Câmeras",
      description: "Oferecemos soluções em alarmes sem mensalidade e câmeras de segurança de alta tecnologia e manutenção corretiva e preventiva para sua residência ou negócio.",
      image: imgCameras
    },
    {
      id: 3,
      title: "Interfone e Controle de Acesso",
      description: "Instalamos e realizamos manutenção em sistemas de interfone e controle de acesso, oferecendo soluções modernas para segurança patrimonial. Atendemos condomínios, empresas e residências com equipamentos de qualidade e configuração personalizada.",
      image: imgControle
    },
    {
      id: 4,
      title: "Limpeza de Galpões com detetização e reparos",
      description: "Oferecemos serviços completos de limpeza industrial e pintura para galpões, incluindo preparação de superfície, tratamento anticorrosivo e aplicação de tintas adequadas ao ambiente, prolongando a vida útil das estruturas.",
      image: imgLimpeza
    },
    {
      id: 5,
      title: "Manutenção e Troca de Amortecedores em Niveladora de Docas",
      description: "Prestamos serviços especializados em niveladoras de docas, realizando manutenção preventiva e corretiva, troca de amortecedores e ajustes necessários para garantir operação segura e eficiente no carregamento e descarregamento.",
      image: imgDocas
    },
    {
      id: 6,
      title: "Outros Serviços",
      description: "Executamos serviços de capina, poda de árvores e diversos reparos em geral. Equipe qualificada para atender demandas de manutenção predial e conservação de áreas externas com agilidade e profissionalismo.",
      image: imgOutros
    }
  ];

  return (
    <section id="servicos" className="servicos-section">
      <div className="servicos-container">
        <h2><strong>Multiserviços para Escolas e Empresas</strong></h2>
        <div className="servicos-grid">
          {servicos.map((servico) => (
            <ServiceCard
              key={servico.id}
              title={servico.title}
              description={servico.description}
              image={servico.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}